import React, { useContext } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import themeContext from "../../../../context/theme/ThemeContext";
import userContext from "../../../../context/users/UserContext";
//Add these imports for fistulogram
import { isMobile } from "react-device-detect";
import { PrimaryButton } from "@fluentui/react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { t } from "i18next";
import { USERTYPES } from "../../../../constants/Constants";
import { AddIcon, DeleteIcon } from "@fluentui/react-icons-mdl2";
import RowBadge from "../../../StudyList/components/Badge/RowBadge";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import loaderContext from "../../../../context/loader/LoaderContext";

/**
 * LLMAddendumTabs
 * Renders "Final Report" / "Addendum" tab strip for LLM users
 */
const LLMAddendumTabs = (props) => {
  const { activeTab, setActiveTab, disableAddendumTab, isWidget,
       // Add these for fistulogram
    showFistolugram,
    setOpenFistolugramModal,
    fistolugramFilePath,
    showFibroid,
    setOpenFibroidModal,
    fibroidFilePath,
    isChildStudyReportState,
    studyReportPdf,
    studyReportPdfUrl,
    handleAttachToggle,
    reportingDoctorName,
   } =
    useContext(studyReportContext);
  const { getThemeColor } = useContext(themeContext);
  const { roles, username } = useContext(userContext);
  const { ref, setLoaderRunning } = useContext(loaderContext);

  const dynamicMargin = isWidget ? "0.3%" : "1.3%";
  const showRightActions =
    studyReportPdf ||
    (!(isMobile && props.readOnly) &&
      !isChildStudyReportState &&
      (showFistolugram || showFibroid));

  const handleOpenPdfInNewTab = () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    window.open(
      studyReportPdfUrl,
      "_blank",
      "noopener,noreferrer"
    );
    setLoaderRunning(false);
    ref.current.complete();
  };

  return (
    <div
      className="llm-addendum-tabs-container"
      style={{
        background: "transparent",
        minHeight: "28px",
        display: "flex",
        alignItems: "flex-end",
        paddingLeft: dynamicMargin,
        paddingRight: dynamicMargin,
        boxSizing: "border-box",
      }}
    >
      <div 
        className="custom-tab-section" 
        style={{ background: "#fff", display: "flex", width: "100%" }} // Add white background here if needed
      >
        <button
          className={`custom-tab ${activeTab === 1 ? "custom-tab-line" : ""}`}
          style={{marginRight: 0 }}
          automation-id="report_original_tab"
          onClick={() => {
            setActiveTab(1);
          }}
        >
          <span
            style={{ 
              color: "black" 
            }}
            className="custom-tab-text"
          >
            Original
          </span>
        </button>
        <button
          style={{
            cursor: disableAddendumTab ? "not-allowed" : "pointer",
          }}
          className={`custom-tab ${activeTab === 2 ? "custom-tab-line" : ""}`}
          automation-id="report_addendum_tab"
          onClick={() => {
            if (!disableAddendumTab) {
              setActiveTab(2);
            }
          }}
          disabled={disableAddendumTab}
        >
          <span
            style={{ color: disableAddendumTab ? "#ccc" : "black" }}
            className="custom-tab-text"
          >
            Addendum
          </span>
        </button>

        {showRightActions && (
        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "3px",
          }}
        >
        {studyReportPdf && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span style={{marginRight: "10px",}}>
              <RowBadge tooltipText="AI Report" name="AI Report" colorObj={{ background: '#E91E63', color: '#FFFFFF' }}/>{" "}
            </span>
            <CustomToolTipHost content={t("button.preview")}>
              <span
                onClick={handleOpenPdfInNewTab}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "10px",
                  cursor: "pointer",
                  color: getThemeColor("primary-color"),
                }}
              >
                <EyeIcon />
              </span>
            </CustomToolTipHost>
            {roles[0] == USERTYPES.RADIOLOGIST && reportingDoctorName && username == reportingDoctorName && (
              <CustomToolTipHost content={studyReportPdf.isAttached ? "Remove" : "Attach"}>
                <span
                  onClick={handleAttachToggle.bind(
                    this,
                    !studyReportPdf.isAttached,
                  )}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "10px",
                    cursor: "pointer",
                    color: "black",
                  }}
                >
                  {studyReportPdf.isAttached ? <DeleteIcon /> : <AddIcon />}
                </span>
              </CustomToolTipHost>
            )}
          </div>
        )}
       
        {/*  Fistulogram Button: Positioned right corner */}
           {!(isMobile && props.readOnly) && !isChildStudyReportState && showFistolugram && (
          <div className="refresh-button" style={{ display: "flex", alignItems: "center", position: "relative" }}>
            <CustomToolTipHost
              content={fistolugramFilePath != null && fistolugramFilePath !== "null" ? "Fistulogram (edited)" : "Fistulogram"}
              id="fistulogram-button-tooltip"
            >
              <PrimaryButton
                onClick={() => setOpenFistolugramModal(true)}
                  /* Added absolute height and minHeight to override standard 32px */
                style={{ 
                  padding: "0px 5px",
                  height: "28px",
                   minHeight: "28px"
                 }}
                text="Fistulogram"
          
              />
            </CustomToolTipHost>
            {fistolugramFilePath != null && fistolugramFilePath !== "null" && (
              <span
                style={{
                  position: "absolute",
                  top: -4,
                  right: -3,
                  width: 10,
                  height: 9,
                  borderRadius: "50%",
                  background: "#ef4444",
                  border: "1.5px solid #ffffff",
                  pointerEvents: "none",
                  zIndex: 1,
                }}
              />
            )}
          </div>
        )} 
        {!(isMobile && props.readOnly) && !isChildStudyReportState && showFibroid && (
          <div className="refresh-button" style={{ display: "flex", alignItems: "center", position: "relative" }}>
            <CustomToolTipHost
              content={fibroidFilePath != null && fibroidFilePath !== "null" ? "Fibroid (edited)" : "Fibroid"}
              id="fibroid-button-tooltip"
            >
              <PrimaryButton
                onClick={() => setOpenFibroidModal(true)}
                style={{ 
                  padding: "0px 5px",
                  height: "28px",
                   minHeight: "28px"
                 }}
                text="Fibroid"
              />
            </CustomToolTipHost>
            {fibroidFilePath != null && fibroidFilePath !== "null" && (
              <span
                style={{
                  position: "absolute",
                  top: -4,
                  right: -3,
                  width: 10,
                  height: 9,
                  borderRadius: "50%",
                  background: "#ef4444",
                  border: "1.5px solid #ffffff",
                  pointerEvents: "none",
                  zIndex: 1,
                }}
              />
            )}
          </div>
        )}
        </div>
        )}

      </div>
    </div>
  );
};

export default LLMAddendumTabs;
